<template>
  <div>
    Lorem ipsum dolor sit amet consectetur, adipisicing elit. Exercitationem
    vero doloremque, repudiandae ab facere quod corporis accusamus quos
    molestiae temporibus reprehenderit explicabo cupiditate obcaecati deserunt
    quasi iusto assumenda tempora qui!

    <pre>
        {{ user }}
    </pre>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      user: (state) => {
        return state.auth.users;
      },
    }),
  },
};
</script>

<style></style>
